import { fallBackTranslate } from './Locale/_index';
import type { IFallBackTemplate } from '@/Templates/FallBack/Types/FallBackTemplate.types';

const SonarFallBack: IFallBackTemplate = {
  locale: fallBackTranslate,
};

export { SonarFallBack };
